var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"index.html"}},[_vm._v("Home")])]),_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"index.html"}},[_vm._v("Products")])]),_c('li',{staticClass:"breadcrumb-item"},[_c('span',[_vm._v("Laptop with retina screen")])])])
}]

export { render, staticRenderFns }